Ext.define('SA.view.RingStudyToolbar', {
    extend: 'SA.view.Toolbar',

    items: [
        {
            xtype: 'pvt-auto-refreshing-location-dropdown',
            itemId: 'locationDropdown'
        }, {
            xtype: 'pvt-fill'
        }, {
            xtype: 'pvt-view-actions-button',
            itemId: 'viewActionsButton',
            margin: '0 10 0 0'
        }, {
            xtype: 'pvt-export-button',
            margin: '0 10 0 0'
        }
    ],

    initComponent() {
        this.callParent();

        this.locationDropdown = this.down('#locationDropdown');
        this.viewActionsButton = this.down('#viewActionsButton');

        this.locationDropdown.setProjectView(this.model);

        this.viewActionsButton
            .setProjectView(this.model)
            .addEditItem()
            .addSeparator()
            .addDeleteItem();
    }
});